import dayjs from 'dayjs';
import { FC } from 'react';
import { Input } from '../../../components/TextField/views';
import {
  setCustomRange,
  useDateRangeValidation,
} from '../../../services/history';
import styles from './RangePicker.module.css';
import { FormattedMessage } from 'react-intl';

interface RangePickerProps {}

export const RangePicker: FC<RangePickerProps> = () => {
  const {
    dateRange: [fromDatetime = '', toDatetime = ''],
  } = useDateRangeValidation();

  return (
    <div className={styles.container}>
      <label htmlFor="history-start" className={styles.label}>
        <span>
          <FormattedMessage id="Date.Start" />:
        </span>
        <Input
          id="history-start"
          type="datetime-local"
          className={styles.input}
          value={dayjs(fromDatetime).format('YYYY-MM-DDTHH:mm')}
          onChange={(e) =>
            setCustomRange([
              e.target.value ? dayjs(e.target.value).toISOString() : '',
              toDatetime,
            ])
          }
        />
      </label>
      <label htmlFor="history-end" className={styles.label}>
        <span>
          <FormattedMessage id="Date.End" />:
        </span>
        <Input
          id="history-end"
          type="datetime-local"
          className={styles.input}
          value={dayjs(toDatetime).format('YYYY-MM-DDTHH:mm')}
          onChange={(e) =>
            setCustomRange([
              fromDatetime,
              e.target.value ? dayjs(e.target.value).toISOString() : '',
            ])
          }
        />
      </label>
    </div>
  );
};
